export const getManageApplicationsSidebar = `
    query getManageApplicationsSidebar {
        getManageApplicationsSidebar {
            sectionLabel
            lines {
                divider
                emptyLine
                indent
                label
                value
            }
        }
    }
`;